import { createStore, combineReducers, compose, applyMiddleware } from "redux";
import { persistStore, persistReducer, createMigrate } from "redux-persist";
import AsyncStorage from "@react-native-async-storage/async-storage";

// let AsyncStorage;

// if (Platform.OS !== "web") {
//   AsyncStorage = require("@react-native-async-storage/async-storage");
// } else {
//   AsyncStorage = require("redux-persist/lib/storage");
// }

// import { createNetworkMiddleware } from "react-native-offline";
import createSagaMiddleware from "redux-saga";
import {
  createFilter,
  createBlacklistFilter,
} from "redux-persist-transform-filter";

import rootReducer, { allReducersName } from "./rootReducer";
import rootSagas from "./rootSagas";
import reduxReset from "redux-reset";

import { ACTION_SEEN } from "./action/constants";
import { Platform } from "react-native";

const blacklistFilters = [
  "loading",
  "requesting",
  "definitionRequesting",
  "uploading",
  "isMobileConnected",
  "campaignsRequesting",
  "isConnected",
  "resetPasswordSent",
  "passwordResetError",
  "selectionRequesting",
  "isValidateRequesting",
  "resourcesRequesting",
  "feedbackRequesting",
  "reviewsRequesting",
  "isEmailRecapRequesting",
  "notificationsHistory",
  "favoriteNotifications"
];

const accumulator: any = [];

const allBlacklistFilters: any = allReducersName?.reduce((prev, curr: any) => {
  const saveSubsetBlacklistFilter: any = createBlacklistFilter(
    curr,
    blacklistFilters,
  );
  prev.push(saveSubsetBlacklistFilter);
  return prev;
}, accumulator);

// migration config
const migrations = {
  7: state => {
    return {
      ...state,
      profileSettings: {
        ...state.profileSettings,
        secondReminderTime: {
          hour: 17,
          minute: 20,
        },
        thirdReminderTime: {
          hour: 12,
          minute: 30,
        },
      },
    };
  },
};

const persistConfig = {
  key: "root",
  version: 7,
  storage: AsyncStorage,
  blacklist: ["network"],
  migrate: createMigrate(migrations),
  transforms: allBlacklistFilters,
};

const networkConfig = {
  // regexActionType: /.*REQUEST$/,
  actionTypes: [ACTION_SEEN],
};

// const networkMiddleware = createNetworkMiddleware(networkConfig);

const composeEnhancers = compose;
// (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const sagaMiddleware = createSagaMiddleware();

const middlewares = [sagaMiddleware];

if (__DEV__ && Platform.OS !== "web") {
  const createDebugger = require("redux-flipper").default;
  middlewares.push(createDebugger());
}

const enhancerWeb = Platform.OS === "web" ? (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose : compose;

const enhancer = composeEnhancers(
  // applyMiddleware(networkMiddleware, sagaMiddleware),
  applyMiddleware(...middlewares),
  reduxReset(),
  enhancerWeb()

);

const persistedReducer = persistReducer(persistConfig, rootReducer);
const intraStore = createStore(persistedReducer, enhancer);


sagaMiddleware.run(rootSagas);

export const store = intraStore;
export const persistor = persistStore(store);

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
